/**
 * Given an image URL, return a promise that resolves when image is loaded.
 */
export var loadImage = function loadImage(url) {
  var crossOrigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'anonymous';
  return new Promise(function (resolve, reject) {
    var img = new window.Image();
    img.crossOrigin = crossOrigin;

    img.onload = function () {
      return resolve(img);
    };

    img.onerror = reject;
    img.setAttribute('src', url);
  });
};
/**
 * Given an image URL and valid cropMask, return a promise that resolves with data URL of cropped image
 */

export var getCroppedImageDataURL = function getCroppedImageDataURL(url, cropMask) {
  return loadImage(url).then(function (image) {
    var canvas = document.createElement('canvas');
    canvas.setAttribute('width', cropMask.width);
    canvas.setAttribute('height', cropMask.height);
    var context = canvas.getContext('2d');
    context.drawImage(image, cropMask.x, cropMask.y, cropMask.width, cropMask.height, 0, 0, cropMask.width, cropMask.height);
    return canvas.toDataURL('image/png');
  });
};